// extracted by mini-css-extract-plugin
export default {"root":"no-authorized_root__YxMIc"};